import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const AnalyticsRoute = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.x1025Analytics?.page(); }, [pathname]);
  return null;
};
